import { WRONG_REGION_CODE } from '../constants/region-keys';

export interface WrongRegionPayload {
    code: string;
    region: string;
    redirectTo: string;
    message?: string;
}

// A login or context call answered with 409 + WRONG_REGION means this account
// lives on another regional stack; redirectTo is that stack's origin.
export const isWrongRegionResponse = (
    status: number | undefined,
    data: unknown
): data is WrongRegionPayload => {
    if (status !== 409 || typeof data !== 'object' || data === null) {
        return false;
    }
    const payload = data as Partial<WrongRegionPayload>;
    return (
        payload.code === WRONG_REGION_CODE &&
        typeof payload.redirectTo === 'string' &&
        payload.redirectTo.length > 0
    );
};

// Login page on the other stack, with the email prefilled. Never carries tokens.
export const buildRegionLoginUrl = (
    redirectTo: string,
    email?: string | null
): string => {
    const url = new URL('/login', redirectTo);
    if (email) {
        url.searchParams.set('email', email);
    }
    return url.toString();
};
